"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _action_type = require("../constants/action_type");
const initialState = {
  src: false,
  dst: false,
  jcamp: false,
  img: false,
  jcampList: false,
  dstList: false
};
const updateConversion = (state, action) => {
  const {
    payload
  } = action;
  const {
    file,
    dst,
    jcamp,
    img,
    jcampList,
    dstList
  } = payload;
  return Object.assign({}, state, {
    src: file,
    dst,
    jcamp,
    img,
    jcampList,
    dstList
  });
};
const insertFile = (state, action) => {
  const {
    payload
  } = action;
  const {
    file
  } = payload;
  return Object.assign({}, state, {
    src: file,
    dst: false,
    jcamp: false,
    img: false,
    jcampList: false,
    dstList: false
  });
};
const fileReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _action_type.FILE.ADD_DONE:
      return insertFile(state, action);
    case _action_type.FILE.CONVERT_DONE:
      return updateConversion(state, action);
    case _action_type.FILE.ADD_FAIL:
    case _action_type.FILE.CONVERT_FAIL:
    case _action_type.MOL.ADD_FAIL:
    case _action_type.MOL.CONVERT_DONE:
    case _action_type.MOL.CONVERT_FAIL:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};
var _default = exports.default = fileReducer;